import * as Oidc from 'oidc-client-ts';

type UserState =
  | {
      savedUrl: string;
    }
  | undefined;

export default class AuthService {
  config: Oidc.UserManagerSettings;

  private manager: Oidc.UserManager;

  constructor(config: Oidc.UserManagerSettings) {
    this.config = config;
    this.manager = new Oidc.UserManager(config);
  }

  get events() {
    return this.manager.events;
  }

  getUserData() {
    return this.manager.getUser();
  }

  refreshToken() {
    return this.manager.signinSilent();
  }

  login() {
    // save current router path in state(local storage) so it can be retrieved when handling complete login callback
    const savedUrl = `${window.location.pathname}${window.location.search}`;

    return this.manager.signinRedirect({ state: { savedUrl } });
  }

  isCallback() {
    if (!window.location.href.split('#/').some(Boolean)) {
      return false;
    }

    if (window.location.href.includes('signin-oidc')) {
      return true;
    }

    return false;
  }

  async completeLogin() {
    const user = await this.manager.signinRedirectCallback();

    const state = user?.state as UserState;

    if (state?.savedUrl) {
      window.history.pushState(null, '', state.savedUrl);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }

    return user;
  }

  logout() {
    return this.manager.signoutRedirect();
  }
}
